































































import { Prop, Vue, Component, Watch }     from 'vue-property-decorator'
import { mapGetters }               from 'vuex'
import ErrorDisplay                 from '@/components/ErrorDisplay.vue'
import { getFileNameFromHeader, base64ToArrayBuffer, formatDateDayHourDateForFileSaving }    from '@/utils/helpers'

/**
 * Composant principal de la pop up d'édition de candidats
 */
@Component({
    computed: {
        ...mapGetters('definitionBarresListeNotesAdmission', ['errorExport'])
    },
    components: {
        ErrorDisplay
    }
})
export default class PopupExportationListeDesNotesAdmission extends Vue {
    @Prop() showModal?: boolean
    @Prop() concours?: any

    exportingIsWorking = false
    returnParams: any = {}

    options_export = {
        type_export: 'liste_resultats',
        resultats_info_cand: false,
        resultats_details_notes : true,
        resultat_concours: true
    }

    concour: any = null
    valBarre: any = null

    listeResulatsChoixColumnExport = [
        { id: 'infos_candidat', checked: false, title: 'Informations des candidats' },
        { id: 'epreuves', checked: true, title: 'Détails des notes aux épreuves' },
        { id: 'resultats', checked: true, title: 'Resultats au concours' }
    ]

    @Watch('showModal')
    getConcourSelected() {
        this.concour = this.$store.getters['definitionDesBarres/selectedConcour']
        for (const b in this.concour.deliberation.barres) {
            this.valBarre = this.concour.deliberation.barres[b].valBarre
        }
    }

    /** Transforme les choix utilisateur des columns, push les infos dans l'objet returnParams */
    choixExportationColumns() {
        this.returnParams = {}
        this.listeResulatsChoixColumnExport.forEach((each) => {
            if (each.checked) {
                this.returnParams[each.id] = each.checked ? 1 : 0
            }
        })
    }

    /** dispatch pour l'exportation, intègre les paramètres pour éviter les erreur xls  */
    lancerExport() {
        this.$store.commit('definitionBarresListeNotesAdmission/SET_ERROR_EXPORT', null) // réinit de l'erreur potentiellement affichée

        const currentDateFormated = formatDateDayHourDateForFileSaving(new Date(Date.now()).toISOString())
        let filenameExport = 'Exportation_Des_Admissions' + currentDateFormated + '.pdf'

        let payload = {}

        switch (this.options_export.type_export) {
            case 'liste_resultats': {
                filenameExport = 'Exportation_Des_Admissions' + currentDateFormated + '.xlsx'
                this.choixExportationColumns()
                payload = {
                    headers:{ 'Content-Disposition': 'attachment; filename=template.xlsx', 'Content-Type': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' },
                    responseType: 'blob',
                    concour_id : this.concours.concour_id,
                    phase_id: this.concours.phase_id,
                    type_export: 'liste_resultats',
                    params: this.returnParams
                }
                break
            }
            case 'tableau_rangs_par_equipe': {
                filenameExport = 'Admissions_Rang_Par_Equipe_' + currentDateFormated + '.pdf'
                payload = {
                    concour_id : this.concours.concour_id,
                    phase_id: this.concours.phase_id,
                    type_export: 'tableau_rangs_par_equipe'
                }
                break
            }
            case 'liste_classes_tri_par_rang': {
                filenameExport = 'Admissions_Classés_Tri_Par_Rang_' + currentDateFormated + '.pdf'
                payload = {
                    concour_id : this.concours.concour_id,
                    phase_id: this.concours.phase_id,
                    type_export: 'liste_classes',
                    alpha: 0
                }
                break
            }
            case 'liste_classes_tri_par_nom': {
                filenameExport = 'Admissions_Classés_Tri_Par_Nom_' + currentDateFormated + '.pdf'
                payload = {
                    concour_id : this.concours.concour_id,
                    phase_id: this.concours.phase_id,
                    type_export: 'liste_classes',
                    alpha: 1
                }
                break
            }
        }

        this.exportingIsWorking = true

        const idInfo = 't_info_' + Math.random()
        const infosToaster = {
            id: idInfo,
            toaster: 'b-toaster-top-right',
            variant: 'primary',
            noCloseButton: true,
            fade: true,
            noAutoHide: true
        }
        this.$bvToast.toast('Exportation en cours de création ...', infosToaster)

        this.$store.dispatch('definitionBarresListeNotesAdmission/exportationAdmission', payload).then((response) => {
            // Téléchargement du fichier fourni
            if (this.options_export.type_export === 'liste_resultats') {
                // Export au format Excel
                const file_name = getFileNameFromHeader(response.headers) || filenameExport
                const url = URL.createObjectURL(new Blob([response.data]))
                const link = document.createElement('a')
                link.href = url
                link.setAttribute(
                    'Download',
                    file_name
                )
                document.body.appendChild(link)
                link.click()
            } else {
                // Export au format PDF
                const file_name = getFileNameFromHeader(response.headers) || filenameExport
                const url = URL.createObjectURL(new Blob([base64ToArrayBuffer(response.data)]))
                const link = document.createElement('a')
                link.href = url
                link.setAttribute(
                    'Download',
                    file_name
                )
                document.body.appendChild(link)
                link.click()
            }

            this.exportingIsWorking = false
            this.$bvToast.hide(idInfo)
            this.returnParams = {}
            this.closeModal()
        }).catch(() => {
            this.exportingIsWorking = false
            this.$bvToast.hide(idInfo)
            // console.log('ko: ', error)
            this.returnParams = {}
        })
    }

    /** fermeture de la modale et reinit des choix utilisateurs  */
    closeModal () {
        this.$store.commit('definitionBarresListeNotesAdmission/SET_ERROR_EXPORT', null) // réinit de l'erreur potentiellement affichée
        this.$emit('reinitShow', null)
    }
}
